/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React, { useEffect } from 'react';
import { initializeAdobeECID, loadAdobeLaunchScript } from '../adobe';
import { useLocation } from 'react-router-dom';
import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency';
import { AdobeAnalytics } from '../AdobeAnalytics';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { initializeClickTracking } from '../events';
import { CypressRunning } from '../../../util/noCypress';
import { useSelector } from 'react-redux';
import { selectCurrentAccountClaims } from '../../../features/azure-b2c/storage';

interface Props {
  children: React.ReactNode | React.ReactNode[];
}
export const AdobeRouter = (props: Props) => {
  const tokenClaims = useSelector(selectCurrentAccountClaims);
  const [mcid, setMcid] = React.useState<string>();

  useEffect(() => {
    if (CypressRunning) {
      return;
    }

    if (tokenClaims?.sub) {
      const adobeAnalytics = AdobeAnalytics.getInstance();
      adobeAnalytics.setUser(tokenClaims.sub, 'registered', 'logged-in');
    }

    if (mcid) {
      const adobeAnalytics = AdobeAnalytics.getInstance();
      adobeAnalytics.setMcid(mcid);
    }
  }, [tokenClaims, mcid]);

  useEffect(() => {
    setDeviceInfo();
    loadAdobeLaunchScript()
      .then(() => {
        console.log('Adobe Launch script loaded successfully');
        initializeAdobeECID(setMcid);
        initializeClickTracking();
      })
      .catch((err) => {
        console.error('Error loading Adobe Launch script:', err);
      });
  }, []);

  const setDeviceInfo = async () => {
    if (Capacitor.isNativePlatform()) {
      const deviceId = await Device.getId();
      const info = {
        deviceId: deviceId.identifier,
        deviceType: Capacitor.getPlatform(),
      };
      AdobeAnalytics.getInstance().updateDeviceInfo(info.deviceType, info.deviceId);
    }

    if (Capacitor.getPlatform() === 'ios') {
      AppTrackingTransparency.getStatus().then((result) => {
        AdobeAnalytics.getInstance().setATTStatus(result.status === 'authorized');
      });
    }
  };
  const location = useLocation();

  useEffect(() => {
    AdobeAnalytics.getInstance().trackEvent('page-load');
  }, [location.pathname]);

  return props.children;
};
